/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".msAnalyticsActivityListActivity_eb56c15b{padding:8px 0}\n"}]);
export const msAnalyticsActivityListActivity = "msAnalyticsActivityListActivity_eb56c15b";